import { Component, Inject, Vue } from 'vue-property-decorator';
import { VERSION } from '@/constants';
import AccountService from '@/shared/service/account.service';
import TranslationService from '@/shared/service/translation.service';
import { TMCZ_DOMAIN } from '@/shared/constants';

@Component
export default class Header extends Vue {
  @Inject('translationService')
  private translationService: () => TranslationService;

  @Inject('accountService')
  private accountService: () => AccountService;

  public version = VERSION ? 'v' + VERSION : '';
  private currentLanguage = this.$store.getters.currentLanguage;

  created() {
    this.translationService().refreshTranslation(this.currentLanguage);
  }

  public changeLanguage(newLanguage: string): void {
    this.translationService().refreshTranslation(newLanguage);
  }

  public isActiveLanguage(key: string): boolean {
    return key === this.$store.getters.currentLanguage;
  }

  public get authenticated(): boolean {
    return this.$store.getters.authenticated;
  }

  public getDomain(): string {
    return TMCZ_DOMAIN;
  }
}
